import { render } from "./transactionsHeader.vue?vue&type=template&id=6a002871&scoped=true"
import script from "./transactionsHeader.vue?vue&type=script&lang=js"
export * from "./transactionsHeader.vue?vue&type=script&lang=js"

import "./transactionsHeader.vue?vue&type=style&index=0&id=6a002871&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a002871"]])

export default __exports__